import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { dashboardZone, addDashboard } from "../api";
import {
  setDashboardZone,
  setDashboardDetails,
  setNewDashboard,
} from "../redux";
import { Col } from "reactstrap";
import { withRouter } from "react-router-dom";
import ShortcutModal from "./ShortcutModal";
import { AddDetails, Alert } from "./";
import { useTranslation } from "react-i18next";

const AddComp = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const token = Cookies.get("token");
  const dashboardMine = useSelector(
    (state) => state.dashboardMine.dashboardMine
  );

  const [activeDash, setActiveDash] = useState(false);
  const [showAddZone, setShowAddZone] = useState(false);
  let [activeIndex, setActiveIndex] = useState(0);
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
    question: false,
    id: "",
    request: "",
  });
  const toggleAlert = () => {
    setShowAlert((prevState) => ({
      ...prevState,
      show: false,
    }));
  };

  useEffect(() => {
    // setActiveIndex(index);
    setActiveDash(true);
    setShowAddZone(false);
  }, []);

  const dashboardDetail = (value, index) => {
    setActiveIndex(index);
    setActiveDash(true);
    setShowAddZone(false);
    const formData = new FormData();

    formData.append("dashboard", value.id);
    dashboardZone(formData, token)
      .then((res) => {
        dispatch(setDashboardDetails(value));

        dispatch(setDashboardZone(res.data.data));
      })

      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        }
      });
  };

  const form = useRef(null);
  const initialValues = {
    caption: "",
  };

  const submitForm = () => {
    const formData = new FormData(form.current);
    addDashboard(formData, token)
      .then((res) => {
        form.current.reset();
        dispatch(
          setNewDashboard({
            id: res.data.data,
            dashboard_caption: formData.get("caption"),
          })
        );
        setShowAlert((prevState) => ({
          ...prevState,
          show: true,
          message: t("خانه جدید با موفقیت اضافه شد."),
          type: "Success",
          question: false,
        }));
        setTimeout(() => {
          toggleAlert();
        }, 5000);
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        }
      });
  };

  const validationSchema = Yup.object({
    caption: Yup.string().required(t("نام ساختمان را وارد کنید.")),
  });

  // const deleteDashboard = (id) => {
  //   let countDevice = 0;
  //   var myHeaders = new Headers();
  //   myHeaders.append("Authorization", token);
  //   var formdata = new FormData();
  //   formdata.append("dashboard", id);
  //   var requestOptions = {
  //     method: "POST",
  //     headers: myHeaders,
  //     body: formdata,
  //     redirect: "follow",
  //   };
  //   fetch("https://assessn.mmaviot.com/api/dashboard_zones", requestOptions)
  //     .then((response) => response.json())
  //     .then((result) => {
  //       result.data.map((zone) => {
  //         var myHeaders = new Headers();
  //         myHeaders.append("Authorization", token);
  //         var formdata = new FormData();
  //         formdata.append("zone", zone.id);
  //         var requestOptions = {
  //           method: "POST",
  //           headers: myHeaders,
  //           body: formdata,
  //           redirect: "follow",
  //         };

  //         fetch("https://assessn.mmaviot.com/api/zone_widgets", requestOptions)
  //           .then((response) => response.json())
  //           .then((result) => {
  //             if (result.data.length !== 0) {
  //               countDevice++;
  //             }

  //             console.log(result.data, countDevice);
  //           })
  //           .catch((error) => console.log("error", error));
  //       });
  //     })
  //     .catch((error) => console.log("error", error));

  //   {
  //     !countDevice
  //       ? setShowAlert((prevState) => ({
  //           ...prevState,
  //           show: true,
  //           message:
  //             "این ساختمان حاوی دستگاه است! ابتدا دستگاه مربوطه حذف گردد.",
  //           type: "Warning",
  //           question: false,
  //         }))
  //       : setShowAlert((prevState) => ({
  //           ...prevState,
  //           show: true,
  //           message: "آیا از حذف این ساختمان اطمینان دارید؟",
  //           type: "Warning",
  //           question: true,
  //           id: id,
  //           request: "dashboard",
  //         }));
  //     setTimeout(() => {
  //       countDevice = false;
  //       setShowAlert((prevState) => ({
  //         ...prevState,
  //         show: false,
  //       }));
  //     }, 2000);
  //   }
  // };

  const deleteDashboard = async (id) => {
    let countDevice = 0;
    var myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    try {
      var formdata = new FormData();
      formdata.append("dashboard", id);
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      let response = await fetch(
        "https://assessn.mmaviot.com/api/dashboard_zones",
        requestOptions
      );
      let result = await response.json();

      for (const zone of result.data) {
        let formdataZone = new FormData();
        formdataZone.append("zone", zone.id);
        let requestOptionsZone = {
          method: "POST",
          headers: myHeaders,
          body: formdataZone,
          redirect: "follow",
        };

        let responseZone = await fetch(
          "https://assessn.mmaviot.com/api/zone_widgets",
          requestOptionsZone
        );
        let resultZone = await responseZone.json();

        if (resultZone.data.length !== 0) {
          countDevice++;
        }
      }

      if (countDevice === 0) {
        setShowAlert((prevState) => ({
          ...prevState,
          show: true,
          message: t("آیا از حذف این ساختمان اطمینان دارید؟"),
          type: "Warning",
          question: true,
          id: id,
          request: "dashboard",
        }));

        setTimeout(() => {
          setShowAlert((prevState) => ({ ...prevState, show: false }));
        }, 10000);
      } else {
        setShowAlert((prevState) => ({
          ...prevState,
          show: true,
          message: t(
            "این ساختمان حاوی دستگاه است! ابتدا دستگاه مربوطه حذف گردد."
          ),
          type: "Warning",
          question: false,
        }));

        setTimeout(() => {
          setShowAlert((prevState) => ({ ...prevState, show: false }));
        }, 10000);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <>
      <div style={{ height: "6vh" }}>
        <Col className="text-center fn">{t("ساختمان جدید")}</Col>
      </div>
      <div style={{ minHeight: "70vh" }}>
        <div>
          <Col className="p-0 mt-2">
            <div className="d-flex align-items-center flex-wrap">
              {dashboardMine?.map((dash, index) => {
                const active = activeIndex === index ? true : false;
                return (
                  <div className="position-relative m-1">
                    <span
                      key={index}
                      onClick={() => dashboardDetail(dash, index)}
                      className={`homeBtn px-3 py-1 cursor mb-2 ml-2 text-center ${
                        active ? "text-white" : "bg-white"
                      } fn12`}
                    >
                      {dash.dashboard_caption}
                    </span>
                    <span
                      onClick={() => deleteDashboard(dash.id)}
                      className="deleteIcon shadow-sm cursor bg-white position-absolute d-block text-dark text-center"
                    >
                      <i className="icon-trash-empty"></i>
                    </span>
                  </div>
                );
              })}
              <span
                className="homeIcon d-flex align-items-center justify-content-center rounded-circle bg-white mx-2 mb-2 text-center cursor"
                onClick={() => {
                  setActiveDash(false);
                  setShowAddZone(true);
                }}
              >
                +
              </span>
            </div>
          </Col>
        </div>
        {activeDash && <AddDetails />}
        {showAddZone && (
          <Formik
            initialValues={initialValues}
            onSubmit={submitForm}
            validationSchema={validationSchema}
          >
            {(props) => (
              <Form ref={form}>
                <div className="mt-4">
                  <div className="homeName w-100 bg-white">
                    <p className="text-right p-2 m-0 fn12">
                      {t("نام ساختمان")}
                    </p>
                    <input
                      type="text"
                      autoFocus
                      value={props.values.caption || ""}
                      placeholder={t("نام ساختمان را وارد کنید.")}
                      className="w-100 border-0 text-center p-2 fn10"
                      name="caption"
                      onChange={props.handleChange}
                      onBlur={props.handleBlur}
                    />
                  </div>
                  <ErrorMessage name="caption">
                    {(errMsg) => (
                      <div className="text-danger text-right fn10 mt-1">
                        {errMsg}
                      </div>
                    )}
                  </ErrorMessage>
                  <div className="d-flex flex-wrap justify-content-center mt-4">
                    <button
                      type="submit"
                      className="border-0 bg-transparent mx-3 d-flex justify-content-center align-items-center flex-column text-center"
                    >
                      <span className="profileAddUser bg-white d-block icon-ok cursor"></span>
                      <small className="fn12 mt-1">{t("تائید")}</small>
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        )}
      </div>
      {showAlert.show && (
        <Alert
          message={showAlert.message}
          type={showAlert.type}
          question={showAlert.question}
          id={showAlert.id}
          request={showAlert.request}
          toggleAlert={toggleAlert}
        />
      )}
      <ShortcutModal />
    </>
  );
};

const Add = withRouter(AddComp);

export { Add };
